<droplist class="trimester-droplist" [items]='items()' [selectedItem]='selectedItem()' (selectionChange)='onSelection($event)' sortBy='customSort'>
</droplist>